import { TilingSprite, Texture } from 'pixi.js';

import { ease } from 'pixi-ease';

export class ParallaxLayer extends TilingSprite {
  private DELTA_X = 1.0;
  private DELTA_Y = 0.5;
  private _viewportX = 0;
  private _viewportY = 0;

  public constructor(mytexture: Texture, w: number, h: number, deltaX: number, deltaY: number) {
    super(mytexture, w, h);
    this.texture = mytexture;
    this.width = w;
    this.height = h;
    this.DELTA_X = deltaX;
    this.DELTA_Y = deltaY;
    this.position.x = 0;
    this.position.y = 0;
    this.tilePosition.x = 0;
    this.tilePosition.y = 0;
  }

  public fadeIn(duration: number) {
    ease.add(this, { alpha: 1 }, { duration });
  }

  public fadeOut(duration: number, stopPoint: number) {
    ease.add(this, { alpha: stopPoint }, { duration });
  }

  public get viewportX(): number {
    return this._viewportX;
  }
  public set viewportX(newViewportX: number) {
    const distanceTravelled = newViewportX - this._viewportX;
    this._viewportX = newViewportX;
    this.tilePosition.x -= distanceTravelled * this.DELTA_X;
  }
  public get viewportY(): number {
    return this._viewportY;
  }
  public set viewportY(newViewportY: number) {
    const distanceTravelled = newViewportY - this._viewportY;
    this._viewportY = newViewportY;
    this.tilePosition.y -= distanceTravelled * this.DELTA_Y;
  }
}
